import React, { Component } from 'react';
import {Route,  withRouter,Switch, } from "react-router-dom";
import auth0Client from './Auth';
import ReactGA from 'react-ga';

import Callback from './Callback';
import PortalLostAndFound from './Portal/PortalLostAndFound';
//import NewClaim from './Portal/NewClaim';
import SocialShare from './Portal/SocialShare';
import Dashboard from './Dashboard/Dashboard';
import LostItem from './LostItem/LostItem';
import Locations from './Locations/Locations';
import AddEditLocation from './Locations/AddEditLocation';
import Venue from './Venue/Venue';
import Users from './Users/Users';
import User from './Users/User';
import Claims from './Claims/Claims';
import Claim from './Claim/Claim';
import NavBar from './NavBar/NavBar';
import PrintLabel from './LostItem/PrintLabel';
import BatchPrintInventory from './LostItem/BatchPrintInventory';
import SecuredRoute from './SecuredRoute/SecuredRoute';
import LostItems from './LostItems/LostItems';
//import Footer from './Footer';
import Intro from './Main/Intro';
import Reports from './Reports/ReportsMenu';
import Support from './Support/Support';
//import ReturnWizard from './Shipments/ReturnWizard';
import ReturnWizard from './Shipments/ReturnWizard2';

import CurrentInventoryReport from './Reports/CurrentInventoryReport';
import AgedInventoryReport from './Reports/AgedInventoryReport';
import CurrentInventoryDetailReport from './Reports/CurrentInventoryDetailReport';
import claimSummaryReport from './Reports/ClaimSummaryReport';
import claimDetailReport from './Reports/ClaimDetailReport';
import ShipmentDetailsReport from './Reports/ShipmentDetailsReport';
import ShipmentSummaryReport from './Reports/ShipmentSummaryReport';
import PTAgedReport from './Reports/PTAgedReport';
import LostItemAuditReport from './Reports/LostItemAuditReport';
import HelpDocs from './Docs/MainDoc';
import ShipCentral from './Shipments/ShipCentral';
import SRItems from './SR/SRItems'
import SRItem from './SR/SRItem'
//import InventoryReport from './Reports/InventoryReport';
import PrintReceipt from './SR/PrintReceipt';
import FoundersReport from './Reports/FoundersReport';
import VendorDispositionReport from './Reports/VendorDispositionReport';
import DispositionReport from './Reports/DispositionReport';
import PrintLocationLabel from './Locations/PrintLocationLabel';
import ReleaseDateReport from './Reports/ReleaseDateReport';
import StorageLocationReport from './Reports/StorageLocationReport';
import QRExpressReport from './Reports/QRExpressReport';
//import {SERVER_URL, LOCAL_URL}  from './Constants';
import AIM from './Claims/AIM';
//import useGaTracker from './UseGATracker'
import{GOOGLE_GA} from './Constants';
import {PageView} from './UseGATracker';
import Disposition from './Disposition/Disposition';
import CurrentInventoryReportAdvanced from './Reports/advanced/CurrentInventoryReportAdv';
import ClaimDetailReportAdvanced from './Reports/advanced/ClaimDetailReportAdvanced';
import ParcelsAdvanced from './Reports/advanced/ParcelsAdvanced';
import PrintStatement from './SR/PrintStatement';
import ShippingReportAdvanced from './Reports/advanced/ShippingReportAdvanced';
const mql = window.matchMedia(`(min-width: 800px)`);

const queryString = require('query-string');



class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checkingSession: true,
      Portal: false,
      social: false,
      callback: false,
      dashboardWarnings: 0,
      openLostItems:0,
      openClaims:0,
      sidebarDocked: mql.matches,
      sidebarOpen: false,
      venueName:'',
      base64Icon:'',
      enableWarehouse:false,
      enableDisposition:false,
      claimFlowUrl:''
    }
   
    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);

    //console.log('using React V: ' + React.version);

    auth0Client.onSessionUpdated=this.onSessionUpdated;

  }

  onSessionUpdated=(venue)=>{
   
    if(auth0Client.getDefaultVenue()){
      let defaultVenue =  auth0Client.getDefaultVenue();
      this.setState({
        venueName: defaultVenue.name,
        base64Icon: defaultVenue.base64Icon,
        venueTypeCd: defaultVenue.venueTypeCd,
        enableWarehouse: defaultVenue.enableWarehouse,
        enableDisposition: defaultVenue.enableDisposition,
        claimFlowUrl:defaultVenue.typeFormUrl
      });
    }else{
      console.log('no set');
    }
  }

  updateDashboardWarnings=(val)=>{
   
    this.setState({
      dashboardWarnings: val
    })
  }
  updateOpenLostItems=(val)=>{
   
    this.setState({
      openLostItems: val
    })
  }
  updateOpenClaims=(val)=>{
   
    this.setState({
      openClaims: val
    })
  }
  componentWillUnmount() {
    if (this.state.mql){
      this.state.mql.removeListener(this.mediaQueryChanged);
    }
   
  }
 
  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }
 
  mediaQueryChanged() {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false });
  }

  initializeReactGA=()=> {
    ReactGA.initialize(GOOGLE_GA);
    ReactGA.pageview('/app');
  }

  upDatePropsFromAuth=(venue)=>{
    console.log('updated venue prop');
  }
   async componentDidMount() {
  
   // console.log('componentDidMount- App')
    mql.addListener(this.mediaQueryChanged);
  
    //console.log('App JS  ' + this.props.location.pathname);
    this.initializeReactGA();
    PageView();
    /// *****************  Handle Portal Calls  *****************
    if (this.props.location.pathname && this.props.location.pathname.includes('PortalLostAndFound')){
      const parsed = queryString.parse(this.props.location.search);
      
    //  console.log('PortalLostAndFound')
     // var temp = '99e78ef1-3c43-433e-ac4c-fcca26852d49';
     console.log('App JS Custom portal color:' + parsed.portalKey);
      this.setState({
        Portal: true,
        portalId:parsed.portalKey,
        portalbgColor : (parsed.bgcolor)? '#' + parsed.bgcolor : 'black'
      });

      return;
    }

    // *****************  Handle lost Item Social  *****************
    if (this.props.location.pathname && this.props.location.pathname.includes('SocialShare')){
      const parsed = queryString.parse(this.props.location.search);
      console.log(parsed);
      this.setState({
        social:true,
        lostItemId: parsed.lostitemid
      });
      return;
    }

        // *****************  Handle Social sourced Claim  *****************
        if (this.props.location.pathname && this.props.location.pathname.includes('NewClaim')){
          const parsed = queryString.parse(this.props.location.search);
          console.log(parsed);
          this.setState({
            socialClaim:true,
            venuePublishID: parsed.venuePublishID,
            lostItemId: parsed.lostitemid
          });
          return;
        }



    // *****************  Handle callback  *****************
    if (this.props.location.pathname === '/callback'){
     // console.log('/callback');

      this.setState({checkingSession:false, callback:true});
      this.onHandleAuthenticationComplete();
      return;

    };

    try {
      console.log('Checking silent auth');
      if (!auth0Client.isAuthenticated()){
        await auth0Client.silentAuth();
      }
      console.log('Checking silent auth: DONE');
      if(auth0Client.getDefaultVenue()){
        let defaultVenue =  auth0Client.getDefaultVenue();
        this.setState({
          venueName: defaultVenue.name,
          base64Icon: defaultVenue.base64Icon,
          venueTypeCd: defaultVenue.venueTypeCd,
          enableWarehouse: defaultVenue.enableWarehouse,
          enableDisposition: defaultVenue.enableDisposition,
          claimFlowUrl:defaultVenue.typeFormUrl
        });
      // console.log('Venue:'+ defaultVenue);
      }else{
        console.log('No Default venue');
      }
    //  window.location.href = 'https://bounte.auth0.com/v2/logout?returnTo=' + LOCAL_URL + '&client_id=Tf3IWtq1vTomIKP1U1g4V5bTw164uh6z';
      this.forceUpdate();
    } catch (err) {
      console.log('Error ComponentDidMount: ' + err.message)
     if (err.error !== 'login_required') console.log(err.error);
    }

    this.setState({checkingSession:false, callback: false});


  }




//   <SecuredRoute exact path='/' component={Main} checkingSession={this.state.checkingSession}/>
//<Route exact path='/LostItems/PrintLabel/:id' component={PrintLabel}/>
// <SecuredRoute  path='/' component={Main} checkingSession={this.state.checkingSession}/>
//<SecuredRoute  path='/' component={Main} checkingSession={this.state.checkingSession}/>
//<SecuredRoute exact path='/Main' component={Main} checkingSession={this.state.checkingSession}/>
toggleOpen=()=> {
  this.setState({ sidebarOpen: !this.state.sidebarOpen });

  
}

onHandleAuthenticationComplete=async()=>{
  
 
}
  renderContent=()=>{
    return(
    <div>
     <NavBar venueName={this.state.venueName} claimFlowUrl={this.state.claimFlowUrl} venueTypeCd ={this.state.venueTypeCd} enableDisposition={this.state.enableDisposition} enableWarehouse={this.state.enableWarehouse}/>
      <Switch>
          <SecuredRoute exact path='/LostItems' component={LostItems} updateOpenLostItems={this.updateOpenLostItems} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Dashboard'  component={Dashboard} checkingSession={this.state.checkingSession} updateDashboardWarning={this.updateDashboardWarnings} updateOpenLostItems={this.updateOpenLostItems}/>
          <SecuredRoute exact path='/LostItem/:lostItemId' component={LostItem}  checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Locations' component={Locations} checkingSession={this.state.checkingSession} />
          <SecuredRoute exact path='/AddEditLocation' component={AddEditLocation} />
          <SecuredRoute exact path='/AddEditLocation/:id' component={AddEditLocation} />
          <SecuredRoute exact path='/Venue' component={Venue} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Users' component={Users} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/User/:userId' component={User} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Claims' component={Claims} updateOpenClaims={this.updateOpenClaims} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/AIM' component={AIM} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/AIM/:id' component={AIM} checkingSession={this.state.checkingSession}/>
          <SecuredRoute  exact path='/FilteredClaims/:filter' component={Claims} checkingSession={this.state.checkingSession}/>
          <SecuredRoute  exact path='/FilteredLostItems/:filter' component={LostItems} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Claim/:claimId' component={Claim} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/NewClaim/:lostItemId/:newflag' component={Claim} checkingSession={this.state.checkingSession}  />
          <SecuredRoute exact path='/ReturnWizard' component={ReturnWizard} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/ShipCentral' component={ShipCentral} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Reports/CurrentInventoryReport' component={CurrentInventoryReport} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Reports/AgedInventoryReport' component={AgedInventoryReport} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Reports/CurrentInventoryDetailReport' component={CurrentInventoryDetailReport} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Reports/ClaimSummaryReport' component={claimSummaryReport} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Reports/ClaimDetailReport' component={claimDetailReport} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Reports/ShipmentDetailsReport' component={ShipmentDetailsReport} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Reports/ShipmentSummaryReport' component={ShipmentSummaryReport}checkingSession={this.state.checkingSession} />
          <SecuredRoute exact path='/Reports/PTAgedReport' component={PTAgedReport}checkingSession={this.state.checkingSession} />  
          <SecuredRoute exact path='/Reports/LostItemAuditReport' component={LostItemAuditReport}checkingSession={this.state.checkingSession} />  
          <SecuredRoute exact path='/Disposition' component={Disposition}checkingSession={this.state.checkingSession} />  
          {
           // <SecuredRoute exact path='/Reports/InventoryReport' component={InventoryReport}checkingSession={this.state.checkingSession} /> 
          } 
         <SecuredRoute exact path='/Reports/FoundersReport' component={FoundersReport} checkingSession={this.state.checkingSession} />  
         <SecuredRoute exact path='/Reports/VendorDispositionReport' component={VendorDispositionReport} checkingSession={this.state.checkingSession} />  
         <SecuredRoute exact path='/Reports/DispositionReport' component={DispositionReport} checkingSession={this.state.checkingSession} />  
         <SecuredRoute exact path='/Reports/QRExpressReport' component={QRExpressReport} checkingSession={this.state.checkingSession} />  
         <SecuredRoute exact path='/Reports/CurrentInventoryReportAdvanced' component={CurrentInventoryReportAdvanced} checkingSession={this.state.checkingSession} />  
         <SecuredRoute exact path='/Reports/ClaimDetailReportAdvanced' component={ClaimDetailReportAdvanced} checkingSession={this.state.checkingSession} />  
         
         <SecuredRoute exact path='/Reports/ParcelsAdvanced' component={ParcelsAdvanced} checkingSession={this.state.checkingSession} />  
  
         
         
          <SecuredRoute exact path='/SRItems' component={SRItems}checkingSession={this.state.checkingSession} />

          <SecuredRoute exact path='/SRItem/:id' component={SRItem} checkingSession={this.state.checkingSession} /> 
          <SecuredRoute exact path='/Docs' component={HelpDocs}checkingSession={this.state.checkingSession} />

          <Route exact path='/callback' component={Callback} onHandleAuthenticationComplete={this.onHandleAuthenticationComplete}/>
          <Route exact path='/' render={(props)=>(<Intro {...props} venueName={this.state.venueName} base64Icon={this.state.base64Icon}/>)} />
          <SecuredRoute exact path='/Reports' component={Reports} checkingSession={this.state.checkingSession}/>
          <SecuredRoute exact path='/Support' component={Support} checkingSession={this.state.checkingSession}/>

          <SecuredRoute exact path='/Reports/ReleaseDateReport' component={ReleaseDateReport}checkingSession={this.state.checkingSession} />   
          <SecuredRoute exact path='/Reports/StorageLocationReport' component={StorageLocationReport}checkingSession={this.state.checkingSession} />   
          <SecuredRoute exact path='/Reports/ShippingReportAdvanced' component={ShippingReportAdvanced}checkingSession={this.state.checkingSession} />  
          
          
          <Route render={() => (<div> Sorry, this page does not exist. </div>)} />

         </Switch>
</div>
     
    
    );
  }
  //<Route exact path='/'  component={Intro} venueName={this.state.venueName} base64Icon={this.state.base64Icon}/>
  /*renderSideNav=()=>{
    return(
      <nav id="sidebar" className="sf-menu navbar-dark bg-dark" >
      <ul className="list-group ">
     

          <li className="list-group-item d-flex justify-content-between align-items-center ">
           <Link to="/Dashboard" >Dashboard </Link>
          
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
              <Link to="/LostItems" >Lost & Found</Link>
              {(this.state.openLostItems >0) ? <span className="badge badge-pill badge-info">{this.state.openLostItems}</span> : ''}
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
              <Link to="/Claims" >Claims</Link>
              {(this.state.openClaims >0) ? <span className="badge badge-pill badge-danger">{this.state.openClaims}</span> : ''}
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
              <Link to="/ShipCentral" >Ship Central</Link>
             
          </li>
      
          <li className="list-group-item d-flex justify-content-between align-items-center">
          <Link to="/Venue" >Venue</Link>
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
          <Link to="/Users" >Users</Link>
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
          <Link disabled={true} to="/Reports">Reports</Link>
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
          <Link disabled={true} to="/Support">Support</Link>
          </li>


      </ul>
  </nav>
    )
  }

  renderOLd=()=>{
    return(
      <div className='container-fluid' style={{ margin: 0, }}>
        




          <div className="row">
              <div className='col-2' >
                {this.renderSideNav()}
              </div>
          
              <div className='col-10'>
              <div style={{ flex: 1, padding: "5px" }}>
                {this.renderContent()}
              </div>
            </div>
           </div>
                 
                <div className='row' >
                  <div className='col-12'>

                       <Footer />

                   </div>
               </div>
      </div> 
    )
  }*/







  render() {
   


    if (this.state.Portal){
      return (<PortalLostAndFound venuePublishID={this.state.portalId} bgColor={this.state.portalbgColor}/>);

    }

    if(this.state.social){
      return (<SocialShare lostItemId={this.state.lostItemId} />);
    }
    if(this.state.socialClaim){
      //return (<NewClaim lostItem={{id: this.state.lostItemId}} venuePublishID={this.state.venuePublishID} />);
      return (null);
    }

    // if print label, then only show the this
    if (this.props.location.pathname && this.props.location.pathname.includes('PrintLabel')){
      // this is a print label 
      return (<Route exact path='/LostItems/PrintLabel/:id' component={PrintLabel}/>);

  }

     // if Batch print label, then only show the this
     if (this.props.location.pathname && this.props.location.pathname.includes('BatchPrintInventory')){
      // this is a print label 
      //console.log('BatchPrintInventory');
      return (<Route exact path='/LostItem/BatchPrintInventory/:params' component={BatchPrintInventory}/>);

  }

   // if print label, then only show the this
   if (this.props.location.pathname && this.props.location.pathname.includes('PrintLocationLabel')){
    // this is a print label 
    return (<Route exact path='/Locations/PrintLocationLabel/:id' component={PrintLocationLabel}/>);

}

  

   // if printing a receipt then use this //
   if (this.props.location.pathname && this.props.location.pathname.includes('SRItem/PrintReceipt')){
    // this is a print receipt 
    return (<Route exact path='/SRItem/PrintReceipt/:id' component={PrintReceipt} />);

}
   // if printing a receipt then use this //
   if (this.props.location.pathname && this.props.location.pathname.includes('SRItem/PrintStatement')){
    // this is a print receipt 
    return (<Route exact path='/SRItem/PrintStatement/:ids' component={PrintStatement} />);

}
  
      return (
       
        <div className='container-fluid' style={{ margin: 0 }}>
        




        <div className="row">
            
        
            <div className='col-12'>
            <div style={{ flex: 1, padding: "5px", marginTop:'16px' }}>
              {this.renderContent()}
            </div>
          </div>
         </div>
               
            
    </div> 
      
      );
       


    }
    

}

export default withRouter(App);
